// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.inventory.LocationProductItemTableResponse */
/* istanbul ignore next */
@GandalfModel
export class LocationProductItemTableResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	a!: number | null;

	@GandalfProperty({ designType: String })
	addDesignation!: string | null;

	@GandalfProperty({ designType: Number })
	addDesignationId!: number | null;

	@GandalfProperty({ designType: Number })
	addPower!: number | null;

	@GandalfProperty({ designType: Number })
	axis!: number | null;

	@GandalfProperty({ designType: Number })
	b!: number | null;

	@GandalfProperty({ designType: Number })
	baseCurve!: number | null;

	@GandalfProperty({ designType: Number })
	bridge!: number | null;

	@GandalfProperty({ designType: Number })
	circumference!: number | null;

	@GandalfProperty({ designType: String })
	color!: string | null;

	@GandalfProperty({ designType: String })
	colorCode!: string | null;

	@GandalfProperty({ designType: Number })
	cylinder!: number | null;

	@GandalfProperty({ designType: Number })
	dbl!: number | null;

	@GandalfProperty({ designType: String })
	description!: string | null;

	@GandalfProperty({ designType: Number })
	diameter!: number | null;

	@GandalfProperty({ designType: Number })
	ed!: number | null;

	@GandalfProperty({ designType: Number })
	edAngle!: number | null;

	@GandalfProperty({ designType: Number })
	eye!: number | null;

	@GandalfProperty({ designType: Number })
	frameColorId!: number | null;

	@GandalfProperty({ designType: Number })
	frameSizeId!: number | null;

	@GandalfProperty({ designType: Number })
	id!: number;

	@GandalfProperty({ designType: Boolean })
	isTrial!: boolean | null;

	@GandalfProperty({ designType: Number })
	lensColorId!: number | null;

	@GandalfProperty({ designType: String })
	lensType!: string | null;

	@GandalfProperty({ designType: Number })
	locationProductId!: number;

	@GandalfProperty({ designType: String })
	material!: string | null;

	@GandalfProperty({ designType: String })
	packaging!: string | null;

	@GandalfProperty({ designType: String })
	productName!: string;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	retail!: number;

	@GandalfProperty({ designType: Number })
	screwToScrew!: number | null;

	@GandalfProperty({ designType: String })
	sku!: string | null;

	@GandalfProperty({ designType: Number })
	sphere!: number | null;

	@GandalfProperty({ designType: Number })
	stockQuantity!: number | null;

	@GandalfProperty({ designType: Boolean })
	stocked!: boolean | null;

	@GandalfProperty({ designType: Number })
	temple!: number | null;

	@GandalfProperty({ designType: String })
	templeUnit!: string | null;

	@GandalfProperty({ designType: String })
	upc!: string | null;

}
